/* eslint-disable */
import PropTypes from 'prop-types'
import { themr } from '../react-css-themr'
import { cx } from '@emotion/css'
import { DIALOG } from '../identifiers'
import Portal from '../hoc/Portal'
import ActivableRenderer from '../hoc/ActivableRenderer'
import InjectButton from '../button/Button'
import InjectOverlay from '../overlay/Overlay'

const factory = (Overlay, Button) => {
  const Dialog = ({
    actions = [],
    active = false,
    children,
    className,
    onEscKeyDown,
    onOverlayClick,
    onOverlayMouseDown,
    onOverlayMouseMove,
    onOverlayMouseUp,
    theme,
    title,
    type = 'normal',
  }) => {
    const actionButtons = actions.map((action, idx) => {
      const combinedClassName = cx(props.theme.button, {
        [action.className]: action.className,
      })
      return <Button key={idx} {...action} className={combinedClassName} />
    })

    const combinedClassName = cx(
      [theme.dialog, theme[type]],
      {
        [theme.active]: active,
      },
      className
    )

    return (
      <Portal className={theme.wrapper}>
        <Overlay
          active={active}
          className={theme.overlay}
          onClick={onOverlayClick}
          onEscKeyDown={onEscKeyDown}
          onMouseDown={onOverlayMouseDown}
          onMouseMove={onOverlayMouseMove}
          onMouseUp={onOverlayMouseUp}
          theme={theme}
          themeNamespace='overlay'
        />
        <div data-react-toolbox='dialog' className={combinedClassName}>
          <section role='body' className={theme.body}>
            {title ? <h6 className={theme.title}>{title}</h6> : null}
            {children}
          </section>
          {actionButtons.length ? <nav className={theme.navigation}>{actionButtons}</nav> : null}
        </div>
      </Portal>
    )
  }

  Dialog.propTypes = {
    actions: PropTypes.arrayOf(
      PropTypes.shape({
        className: PropTypes.string,
        label: PropTypes.string,
        children: PropTypes.node,
      })
    ),
    active: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    onEscKeyDown: PropTypes.func,
    onOverlayClick: PropTypes.func,
    onOverlayMouseDown: PropTypes.func,
    onOverlayMouseMove: PropTypes.func,
    onOverlayMouseUp: PropTypes.func,
    theme: PropTypes.shape({
      active: PropTypes.string,
      body: PropTypes.string,
      button: PropTypes.string,
      dialog: PropTypes.string,
      navigation: PropTypes.string,
      overlay: PropTypes.string,
      title: PropTypes.string,
      wrapper: PropTypes.string,
    }),
    title: PropTypes.string,
    type: PropTypes.string,
  }

  return ActivableRenderer()(Dialog)
}

const Dialog = factory(InjectOverlay, InjectButton)
export default themr(DIALOG)(Dialog)
export { Dialog }
export { factory as dialogFactory }
